import { cva } from 'class-variance-authority';

export const field = cva(['flex', 'flex-col']);

export const hint = cva(['mt-8'], {
  variants: {
    intent: {
      hint: ['text-grayscale300'],
      error: ['text-error400'],
    },
  },
});
